import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const CryoprecipitatePage = lazy(
  () => import('@/pages/cryoprecipitate/ui/index'),
)

export const Route = createFileRoute('/_protected/expedition/cryoprecipitate')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <CryoprecipitatePage />
    </Suspense>
  ),
})
